import { get } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const getOfferSummary = (documentId, siteId) => {
  return get(`${url}/v2/leasingoffer/${documentId}/${siteId}/summary`);
};

const getOfferKpi = (documentId, siteId) => {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/kpis`);
};

const exp = {
  getOfferSummary,
  getOfferKpi
};
export default exp;
